function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect, useState } from 'react';
import { Button, Callout, Typography } from 'seagull';
import cn from 'classnames';
import { useShallowStore, useStoreActions } from "../../../contexts";
import { StepPage } from "../../components/StepPage";
import { AgreementHeader } from "../../components/AgreementHeader";
import { useResponsive } from "../../contexts";
import { NEW_BUSINESS_NAME_FLAG, useWelcomeStepUtils } from "./welcomeStepUtils";
import { TextBox } from "../../components/TextBox";
import { useCobStorage } from "../CobStorageContext";
import styles from "./WelcomeStep.module.scss";
import { selectors } from "../../../store/state-selectors";
import { replacePlaceholders } from "../../../utils/introductory-message.utils";
import { COBStep, getStepName, getNextStepButtonText } from "../ClientOnboarding.utils";
import { useCobConfig } from "../CobConfigContext";
import { relationshipModel } from "../../../models";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import RecipientDetails from "../../../components/RecipientDetails/RecipientDetails";
export default function WelcomeStep(_ref) {
  var _selectedWorkspace$na, _relationship$buyer$f, _relationship$signato;
  let {
    isReviewer,
    onDone
  } = _ref;
  const {
    isMobile
  } = useResponsive();
  const {
    relationship,
    isPreview
  } = useCobConfig();
  const {
    MULTIPLE_RECEPIENTS = false
  } = useFeatureFlags();
  const {
    getFromStorage
  } = useCobStorage(relationship);
  const {
    createOrSelectBusiness,
    newBusinessWorkspace
  } = useWelcomeStepUtils({
    relationship
  });
  const [worksAt, workspaces] = useShallowStore(state => [selectors.user.business(state), selectors.user.workspaces(state)]);
  const {
    logBI
  } = useStoreActions();
  const hasAdditionalRecipients = relationshipModel.hasAdditionalRecipients(relationship);
  const getSelectedWorkspace = () => {
    const shouldUseRelationshipCustomer = relationship.isSample || isPreview;
    const isNewBusinessSelected = relationship.suggestedCustomerName && !(newBusinessWorkspace !== null && newBusinessWorkspace !== void 0 && newBusinessWorkspace.id) && getFromStorage('select_new_business') !== false;
    const newBusiness = {
      id: NEW_BUSINESS_NAME_FLAG,
      name: relationship.suggestedCustomerName
    };
    return shouldUseRelationshipCustomer ? relationship.customer : isNewBusinessSelected ? newBusiness : worksAt || (workspaces === null || workspaces === void 0 ? void 0 : workspaces[0]);
  };
  const [selectedWorkspace, setSelectedWorkspace] = useState(getSelectedWorkspace());
  useEffect(() => {
    setSelectedWorkspace(getSelectedWorkspace());
  }, [worksAt, relationship]);
  return /*#__PURE__*/React.createElement(StepPage, {
    header: getStepName(COBStep.welcome, relationship),
    primaryBtn: /*#__PURE__*/React.createElement(Button, {
      "data-testid": (relationship.isSample ? 'test-agreement-' : '') + 'step1-next-btn',
      onClick: () => {
        if (!isPreview) {
          logBI(10801);
        }
        if ((selectedWorkspace === null || selectedWorkspace === void 0 ? void 0 : selectedWorkspace.id) === NEW_BUSINESS_NAME_FLAG) {
          createOrSelectBusiness(NEW_BUSINESS_NAME_FLAG);
        }
        onDone();
      }
    }, getNextStepButtonText(COBStep.welcome, relationship)),
    testid: "welcome-step"
  }, /*#__PURE__*/React.createElement(TextBox, null, isReviewer && !MULTIPLE_RECEPIENTS && /*#__PURE__*/React.createElement("div", {
    className: styles.reviewerCallout
  }, /*#__PURE__*/React.createElement(Callout, {
    "data-testid": "reviewer-callout"
  }, "You are welcome to review the proposal and add a payment method. Only", ' ', relationshipModel.buyerFullName(relationship), " (", relationshipModel.buyerEmail(relationship), ") can select packages and optional services, if available.")), /*#__PURE__*/React.createElement(AgreementHeader, {
    relationship: relationship,
    companyName: (_selectedWorkspace$na = selectedWorkspace === null || selectedWorkspace === void 0 ? void 0 : selectedWorkspace.name) !== null && _selectedWorkspace$na !== void 0 ? _selectedWorkspace$na : '',
    className: cn(styles.withHorizontalBorder, {
      [styles.mobile]: isMobile
    }),
    isPreview: isPreview
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph1",
    showWhiteSpaces: true,
    breakWords: true,
    className: cn(styles.coverLetter, {
      [styles.mobile]: isMobile
    })
  }, replacePlaceholders(relationship.customNotificationText, (_relationship$buyer$f = relationship.buyer.firstName) !== null && _relationship$buyer$f !== void 0 ? _relationship$buyer$f : '', relationship.vendor.name)), hasAdditionalRecipients && MULTIPLE_RECEPIENTS && /*#__PURE__*/React.createElement("div", {
    "data-testid": "additional-recipients-section",
    className: styles.withHorizontalBorder
  }, /*#__PURE__*/React.createElement(Typography, {
    weight: "normal"
  }, "Additional recipients"), (_relationship$signato = relationship.signatories) === null || _relationship$signato === void 0 ? void 0 : _relationship$signato.map((signatory, index) => /*#__PURE__*/React.createElement(RecipientDetails, _extends({}, signatory, {
    key: signatory.id,
    badge: relationshipModel.hasSignatorySigned(relationship, signatory.id) ? 'signed' : 'required',
    testid: "welcome-step-signatory-".concat(index)
  }))), relationship.reviewers.map((reviewer, index) => /*#__PURE__*/React.createElement(RecipientDetails, _extends({}, reviewer, {
    key: reviewer.id,
    testid: "welcome-step-reviewer-".concat(index)
  }))))));
}